module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBold.448145e.ttf";